<template>
  <ion-page ref="pageElement" :class="(hideTabNavigation) ? 'hidden-tabs' : 'visible-tabs'">
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" v-if="!hideTabNavigation" id="main-tabs">
        <ion-tab-button class="tracking-tab side-button" @click="openTrackingMenu()">
          <AnimatedLogo stopPattern="small" class="logo"></AnimatedLogo>
          <ion-label>{{ i18n.$t('tracking.title') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button ref="animalsTab" class="animal-tab" tab="animals" href="/health/animals">
          <AnimatedLogo stopPattern="parallel-diagonal" class="logo"></AnimatedLogo>
          <ion-label>{{ i18n.$t('animal_record.title.subjects') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button ref="recordTab" class="record-tab" tab="record" href="/health/record">
          <AnimatedLogo stopPattern="cross" class="logo"></AnimatedLogo>
          <ion-label>{{ i18n.$t('animal_record.title.record') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button class="encyclopedia-tab" tab="encyclopedia" href="/health/encyclopedia">
          <AnimatedLogo stopPattern="offset" class="logo"></AnimatedLogo>
          <ion-label>{{ i18n.$t('encyclopedia.title') }}</ion-label>
        </ion-tab-button>
        <div class="empty-tab-border-placeholder"></div>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonPage, IonRouterOutlet, menuController, onIonViewDidLeave } from '@ionic/vue';

import { useI18n } from "@/utils/i18n";
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { handlePageLeave } from '@/utils/interaction';

import AnimatedLogo from '@/components/AnimatedLogo.vue';

export default {
  name: 'Tabs',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonPage, IonRouterOutlet, AnimatedLogo },
  setup() {
    const i18n = useI18n();

    const animalsTab = ref(null);

    const router = useRouter();
    const route = useRoute();

    const pageElement = ref(null);

    //Holds boolean if current route should hide tab navigation
    const hideTabNavigation = computed(() => {
      if ('hideTabNavigation' in route.meta) {
       return route.meta.hideTabNavigation
      }

      return false;
    });

    const openTrackingMenu = function() {
      menuController.open('side-component');
    }

    onIonViewDidLeave(() => handlePageLeave(pageElement.value));

    return {
      i18n,
      pageElement,
      hideTabNavigation,
      openTrackingMenu,
      animalsTab,
      router
    }
  }
}
</script>

<style>
ion-split-pane.split-pane-visible .tracking-tab.side-button {
  display: none!important;
}
</style>

<style scoped>
  .tracking-tab {
    --color: var(--anirec-color-blue-tints-30);
    --color-selected: var(--ion-color-quaternary);
    max-width: 80px;
    /* border-top: var(--global-nav-divider-border);
    border-right: var(--global-nav-divider-border);
    border-bottom: var(--global-nav-divider-border);
    border-radius: 0px 20px 20px 0px; */
  }

  .dark .tracking-tab {
    --color: var(--ion-color-quaternary);
  }

  .tab-selected ~ .empty-tab-border-placeholder {
    display: none;
  }

  .empty-tab-border-placeholder {
    pointer-events: none;
    border-top: var(--global-tab-bar-border);
    background: var(--ion-tab-bar-outer-background);
    position: absolute;
    top: 0px;
    width: 100%;
    height: 50%;
    z-index: -1;
  }

  .record-tab {
    --color: var(--anirec-color-blue-tints-30);
    --color-selected: var(--ion-color-secondary);
  }

  .dark .record-tab {
    --color: var(--ion-color-secondary);
  }

  .animal-tab {
    --color: var(--anirec-color-blue-tints-30);
    --color-selected: var(--ion-color-primary);
    margin-left: auto;
  }

  .dark .animal-tab {
    --color: var(--ion-color-primary);
  }

  .encyclopedia-tab {
    --color: var(--anirec-color-blue-tints-30);
    --color-selected: var(--ion-color-tertiary);
    margin-right: auto;
  }

  .dark .encyclopedia-tab {
    --color: var(--ion-color-tertiary);
  }

  .logo {
    margin-top: 4px;
    font-size: 24px;
    margin-bottom: 5px;
  }

  ion-tab-button {
    flex-direction: column;
  }

  ion-label {
    font-size: 0.9em;
    font-weight: var(--weight-level-semibold);
  }
</style>
